import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    mainTable: {
        marginBottom: theme.spacing(6),
    },
    titleContainer: {
        display: "flex",
        gap: "24px",
    },
}));
